import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as utils from '../common/Utils.js'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const GameContainer = (props) => {
  const navigate = useNavigate();
  let games = props.games;
  let teams = props.teams;
	let gameID = props.gameID;
  let showPlaceholders = props.showPlaceholders;
  let showSeeds = props.showSeeds

  const game = utils.getGameForID(games, gameID)

  if (showSeeds === undefined && game.type === 'playoff') {
    showSeeds = true
  }

  let gameTBD = false;

  let awayTeam;
  let homeTeam;
  if (game.awayTeamID && !showPlaceholders) {
    awayTeam = utils.getTeamForID(teams, game.awayTeamID);
    awayTeam.record = utils.getRecordForID(games, game.awayTeamID)
  } else {
    const placeholderName = game.awayTeamPlaceholder
    awayTeam = {
      name: placeholderName || 'TBD',
      record: '-',
      seed: ''
    };
    gameTBD = true;
  }

  if (game.homeTeamID  && !showPlaceholders) {
    homeTeam = utils.getTeamForID(teams, game.homeTeamID);
    homeTeam.record = utils.getRecordForID(games, game.homeTeamID)
  } else {
    const placeholderName = game.homeTeamPlaceholder
    homeTeam = {
      name: placeholderName || 'TBD',
      record: '-',
      seed: ''
    };
    gameTBD = true;
  }

  let hours = game.date.getHours();
  let hoursLabel = 'AM'
  if(hours >= 12){
    hoursLabel = 'PM';
  }

  if(hours > 12){
    hours -= 12;
  }
  if(hours == 0){
    hours = 12;
  }

  let today = Date.now();

  let gameStatusText = 'Pending';
  if (game.status === 'completed') {
    if (game?.overtime) {
      // This field only exists for certain games today. Add it for all fields, defaulting to false.
      gameStatusText = 'Final / OT'
    } else if (game?.forfeit) {
      // This field doesn't exist today. Add it in the future by going through game stats and adding if it was a forfeit
      gameStatusText = 'Forfeit'
    } else {
      gameStatusText = 'Final'
    }
  } else if (game.status === 'cancelled') {
    gameStatusText = 'Cancelled'
  }

  if (game.date > today && game.type !== 'playoff' && game.status !== 'cancelled') {
    return (
      <div className='league-game-container' onClick={() => {
        navigate(`/games/${game.id}`)
      }} key={game.id + '-game-container'}>
        <div className='league-game-team-names-and-scores'>
          <div className='league-game-team-names'>
            <p className='league-game-team-name' key={game.id + '-away-name'}>{ awayTeam.name.toUpperCase() }</p>
            <p className='league-game-team-name' key={game.id + '-home-name'}>{ homeTeam.name.toUpperCase() }</p>
          </div>
          <div className='league-game-team-records'>
            <p className='league-game-team-record' key={game.id + '-away-record'}>{ awayTeam.record }</p>
            <p className='league-game-team-record' key={game.id + '-home-record'}>{ homeTeam.record }</p>
          </div>
        </div>
        <div className='league-game-time-and-stats'>
          <p className='league-game-time'>{ utils.abbvWeekday(game.date.getDay()) }, { game.date.getMonth() + 1 }/{ game.date.getDate() }</p>
          <p className='league-game-time'>{ hours }:{ game.date.getMinutes().toString().padStart(2, '0') } { hoursLabel }</p>
          <p className='league-game-time'>{ utils.getLocationName(game.location, true) }</p>
        </div>
      </div>
    )
  } else if (game.type !== 'playoff') {
    return (
      <div className='league-game-container' onClick={() => {
        navigate(`/games/${game.id}`)
      }} key={game.id + '-game-container'}>
        <div className='league-game-team-names-and-scores'>
          <div className='league-game-team-names'>
            <p className={ game.winner && game.winner === game.awayTeamID ? 'league-game-team-name game-winner' : 'league-game-team-name' } key={game.id + '-away'}>{ awayTeam.name.toUpperCase() }</p>
            <p className={ game.winner && game.winner === game.homeTeamID ? 'league-game-team-name game-winner' : 'league-game-team-name' } key={game.id + '-home'}>{ homeTeam.name.toUpperCase() }</p>
          </div>
          <div className='league-game-team-scores'>
            <p className={ game.winner && game.winner === game.awayTeamID ? 'league-game-team-score game-winner' : 'league-game-team-score' } key={game.id + '-away-score'}>{ game.status === 'completed' ? game.score.away : '' }</p>
            <p className={ game.winner && game.winner === game.homeTeamID ? 'league-game-team-score game-winner' : 'league-game-team-score' } key={game.id + '-home-score'}>{ game.status === 'completed' ? game.score.home : '' }</p>
          </div>
        </div>
        <div className='league-game-time-and-stats'>
          <p className='league-game-time'><b>{ gameStatusText }</b></p>
          <p className='league-game-time'>{ game.date.getMonth() + 1 }/{ game.date.getDate() }</p>
          { game.status !== 'cancelled' &&
          <p className='league-game-time'>{ utils.getLocationName(game.location, true) }</p>
          }
        </div>
      </div>
    );
  } else if (game.date > today) {
    return (
      <div className='league-game-container' onClick={() => {
        navigate(`/games/${game.id}`)
      }} key={game.id + '-game-container'}>
        <div className='league-game-team-names-and-seeds-and-scores'>
          <div className='league-game-team-names-and-seeds'>
            <div className='league-game-team-seeds'>
              <p className='league-game-team-seed' key={game.id + '-away-seed'}>{ showSeeds ? awayTeam.seed : '' }</p>
              <p className='league-game-team-seed' key={game.id + '-home-seed'}>{ showSeeds ? homeTeam.seed : '' }</p>
            </div>
            <div className='league-game-team-names'>
              <p className={ game.winner && game.winner === game.awayTeamID ? 'league-game-team-name game-winner' : 'league-game-team-name' } key={game.id + '-away'}>{ awayTeam.name.toUpperCase() }</p>
              <p className={ game.winner && game.winner === game.homeTeamID ? 'league-game-team-name game-winner' : 'league-game-team-name' } key={game.id + '-home'}>{ homeTeam.name.toUpperCase() }</p>
            </div>
          </div>
          <div className='league-game-team-scores-with-seeds'>
            <p className={ game.winner && game.winner === game.awayTeamID ? 'league-game-team-score game-winner' : 'league-game-team-score' } key={game.id + '-away-score'}>{ game.status === 'completed' ? game.score.away : '' }</p>
            <p className={ game.winner && game.winner === game.homeTeamID ? 'league-game-team-score game-winner' : 'league-game-team-score' } key={game.id + '-home-score'}>{ game.status === 'completed' ? game.score.home : '' }</p>
          </div>
        </div>
        <div className='league-game-time-and-stats'>
          <p className='league-game-time'>{ utils.abbvWeekday(game.date.getDay()) }, { game.date.getMonth() + 1 }/{ game.date.getDate() }</p>
          <p className='league-game-time'>{ hours }:{ game.date.getMinutes().toString().padStart(2, '0') } { hoursLabel }</p>
          <p className='league-game-time'>{ utils.getLocationName(game.location, true) }</p>
        </div>
      </div>
    )
  } else {
    return (
      <div className='league-game-container' onClick={() => {
        navigate(`/games/${game.id}`)
      }} key={game.id + '-game-container'}>
        <div className='league-game-team-names-and-seeds-and-scores'>
          <div className='league-game-team-names-and-seeds'>
            <div className='league-game-team-seeds'>
              <p className='league-game-team-seed' key={game.id + '-away-seed'}>{ showSeeds ? awayTeam.seed : '' }</p>
              <p className='league-game-team-seed' key={game.id + '-home-seed'}>{ showSeeds ? homeTeam.seed : '' }</p>
            </div>
            <div className='league-game-team-names'>
              <p className={ game.winner && game.winner === game.awayTeamID ? 'league-game-team-name game-winner' : 'league-game-team-name' } key={game.id + '-away'}>{ awayTeam.name.toUpperCase() }</p>
              <p className={ game.winner && game.winner === game.homeTeamID ? 'league-game-team-name game-winner' : 'league-game-team-name' } key={game.id + '-home'}>{ homeTeam.name.toUpperCase() }</p>
            </div>
          </div>
          <div className='league-game-team-scores-with-seeds'>
            <p className={ game.winner && game.winner === game.awayTeamID ? 'league-game-team-score game-winner' : 'league-game-team-score' } key={game.id + '-away-score'}>{ game.status === 'completed' ? game.score.away : '' }</p>
            <p className={ game.winner && game.winner === game.homeTeamID ? 'league-game-team-score game-winner' : 'league-game-team-score' } key={game.id + '-home-score'}>{ game.status === 'completed' ? game.score.home : '' }</p>
          </div>
        </div>
        <div className='league-game-time-and-stats'>
          <p className='league-game-time'><b>{ gameStatusText }</b></p>
          <p className='league-game-time'>{ game.date.getMonth() + 1 }/{ game.date.getDate() }</p>
          <p className='league-game-time'>{ utils.getLocationName(game.location, true) }</p>
        </div>
      </div>
    )
  }
}

export default GameContainer
